import "../stylesheets/token.scss";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
const jQuery = require("../src/theme/jquery.min");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

const wowjs = require("../src/theme/wow.min");
global.WOW = wowjs;
window.WOW = wowjs;

require("../src/theme/main");
